// extracted by mini-css-extract-plugin
module.exports = {"managers":"style_managers__igH2k","manager":"style_manager__N3_MT","managerPhoto":"style_manager-photo__x7thg"};